<template>
  <div class="home">
    <h1>Registrazione Garanzia</h1>
    <hr>

    <ul class="nav nav-pills mb-4">
      <li class="nav-item">
        <span :class="'nav-link ' + ( current_state == 'start' ? 'active' : '')" aria-current="page" href="#">Garanzia</span>
      </li>
      <li class="nav-item">
        <span :class="'nav-link ' + ( current_state == 'registration' ? 'active' : '')" href="#">Dati Registrazione</span>
      </li>
      <li class="nav-item">
        <span :class="'nav-link ' + ( current_state == 'result' ? 'active' : '')" href="#">Esito</span>
      </li>
    </ul>


    <div class="card" v-if="current_state == 'start'">
      <div class="card-body">
        <h4 class="mb-3">Garanzia</h4>

          <div class="row">
            <div class="col">
              <label>Inserire il codice della garanzia</label>
            </div>

            <div class="col">
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.code ? 'is-invalid' : '')" v-model="data.code">
            </div>

            <div class="col">
              <button :disabled="!data.code" class="btn btn-primary w-100" @click.prevent="checkCodeAvailability">Verifica il codice e procedi</button>
            </div>
          </div>
          

      </div>
    </div>



    <div class="card" v-if="current_state == 'registration'">
      <div class="card-body">
        Stai registrando la garanzia con codice <strong class="text-primary">{{ data.code }}</strong>
        <hr>
        <h5 class="mb-3">Registrante</h5>


        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="company_name">Ragione sociale</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.company_name ? 'is-invalid' : '')" id="company_name" v-model="data.company_name" required>
            </div>
          </div>
          <!--
          <div class="col-sm-4">
            <div class="form-group">
              <label for="legal_representative_last_name">Cognome Rappresentante Legale</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.legal_representative_last_name ? 'is-invalid' : '')" id="legal_representative_last_name" v-model="data.legal_representative_last_name" required>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="legal_representative_first_name">Nome Rappresentante Legale</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.legal_representative_first_name ? 'is-invalid' : '')" id="legal_representative_first_name" v-model="data.legal_representative_first_name" required>
            </div>
          </div>
          -->          
          <div class="col-sm-6">
            <div class="form-group">
              <label for="vat_code">Partita IVA</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.vat_code ? 'is-invalid' : '')" id="vat_code" v-model="data.vat_code" required>
            </div>
          </div>
        </div>

        <!--
        <div class="row">
          <div class="col-sm-3">
            <div class="form-group">
              <label for="vat_code">Partita IVA</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.vat_code ? 'is-invalid' : '')" id="vat_code" v-model="data.vat_code" required>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="invoice_code">Codice Destinatario</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.invoice_code ? 'is-invalid' : '')" id="invoice_code" v-model="data.invoice_code" required>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="email">Email</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.email ? 'is-invalid' : '')" id="email" v-model="data.email" required>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="phone">Numero di telefono</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.phone ? 'is-invalid' : '')" id="phone" v-model="data.phone" required>
            </div>
          </div>
        </div>
        -->

        <!--
        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="address">Indirizzo</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.address ? 'is-invalid' : '')" id="address" v-model="data.address" required>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label for="zip_code">Codice Postale</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.zip_code ? 'is-invalid' : '')" id="zip_code" v-model="data.zip_code" required>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label for="city">Città</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.city ? 'is-invalid' : '')" id="city" v-model="data.city" required>
            </div>
          </div>
          <div class="col-sm-2" v-if="districts">
            <div class="form-group">
              <label for="district_code">Provincia</label>
              <select :class="'form-control mb-3 ' + ( validation_errors.district_code ? 'is-invalid' : '')" id="district_code" v-model="data.district_code" required>
                <option value="">---</option>
                <option :value="d.sigla" v-for="d in districts" :key="d.sigla">{{ d.sigla }}</option>
              </select>
            </div>
          </div>
        </div>
        -->
          
        

      
        <hr>

        <h5 class="mb-3">Dati Registrazione</h5>

        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="activated_at">Data decesso</label>
              <input type="date" :class="'form-control mb-3 ' + ( validation_errors.activated_at ? 'is-invalid' : '')" id="activated_at" v-model="data.activated_at" required>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="corpse_last_name">Cognome Salma</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.corpse_last_name ? 'is-invalid' : '')" id="corpse_last_name" v-model="data.corpse_last_name" required>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="corpse_first_name">Nome Salma</label>
              <input type="text" :class="'form-control mb-3 ' + ( validation_errors.corpse_first_name ? 'is-invalid' : '')" id="corpse_first_name" v-model="data.corpse_first_name" required>
            </div>
          </div>
        </div>


        <div class="my-4 form-check">
          <input type="checkbox" :class="'form-check-input ' + ( validation_errors.corpse_first_name ? 'is-invalid' : '') " v-model="data.privacy_acceptance">
          <label class="form-check-label">
            Ho preso visione delle <a href="http://docs.coccatoemezzetti.com/foto/Condizioni_Privacy.pdf" target="_blank">condizioni sulla Privacy Policy</a>
          </label>
        </div>


        <div class="mt-3">
          <button class="btn btn-primary w-100" @click.prevent="submitForm">Procedi con l'inserimento</button>
        </div>
        
      </div>

    </div>


    <div class="card" v-if="current_state == 'result'">
      <div v-if="insert_result.success" class=" text-center py-4">
        <div class="text-success h1 mb-5">Registrazione effettuata correttamente</div>
        <button class="btn btn-primary" @click.prevent="downloadWarrantyPdf( insert_result.warranty_data.id, insert_result.warranty_data.code, insert_result.warranty_data.vat_code, )">Scarica il certificato in PDF</button>
      </div>
      
      <div v-else  class=" text-center py-4">
        <div class="text-danger h1 mb-5">Errore nella registrazione</div>
        <button class="btn btn-primary" @click.prevent="current_state = 'start'">Riprova</button>

      </div>

    </div>



  </div>
</template>

<script>
// @ is an alias to /src

import CmMixin from '../../../webapp/src/mixins/CmMixin'
//import CmMixin from '../mixins/CmMixin'

export default {
  mixins: [ CmMixin ],
  name: 'Insert',
  data: () => {
		return {
      districts: null,
      // current_state: 'registration',
      current_state: 'start',

      validation_errors : {

      },

      data: {
        id: '',
        code: '',

        company_name: '',
        legal_representative_last_name:  '',
        legal_representative_first_name:  '',

        vat_code:  '',
        invoice_code:  '',
        email:  '',
        phone:  '',

        address:  '',
        zip_code:  '',
        city:  '',
        district_code:  '',

        activated_at: null,
        corpse_last_name: '',
        corpse_first_name: '',

        privacy_acceptance: '',
      },

      insert_result: {},
			
		}
	},
  mounted: function(){





    this.getDistricts();
    
  },
  methods:{


    getDistricts: function(  ){
       
      var self = this;
    
      this.api.get( 'misc/getDistricts' )
      .then(function (response) {

          if(response.data.districts){
            self.districts  = response.data.districts;
          }
         
      })
      .catch(function (error) {
          self.notification.error('Errore nella verifica del codice');
      });
    
    },

    checkCodeAvailability: function( callback ){
       
      var self = this;
    
      this.api.get( 'warranty/checkCodeAvailability/' + this.data.code )
      .then(function (response) {

        

          if(response.data.is_available){
            self.current_state  = 'registration';

            self.notification.success( 'Il codice inserito è valido' );
            
          }
          else{
            
            self.notification.error( 'Il codice inserito non è valido' );
          }

          if( typeof callback === 'function')
            callback();
      })
      .catch(function (error) {
          self.notification.error('Errore nella verifica del codice');
      });
    
    },
  /*
    validateForm: function(  ){

      var fields = [
        { name: 'company_name', type: 'text', required: true },
        { name: 'legal_representative_last_name', type: 'text', required: true },
        { name: 'legal_representative_first_name', type: 'text', required: true },
        { name: 'vat_code', type: 'text', required: true },
        { name: 'invoice_code', type: 'text', required: true },
        { name: 'email', type: 'email', required: true },
        { name: 'phone', type: 'text', required: true },
        { name: 'address', type: 'text', required: true },
        { name: 'zip_code', type: 'number', required: true },
        { name: 'city', type: 'text', required: true },
        { name: 'district_code', type: 'text', required: true },
        { name: 'corpse_last_name', type: 'text', required: true },
        { name: 'corpse_first_name', type: 'text', required: true },
      ];

     
      var errors_count = 0;
      var errors = {};

      for( var i in fields ){
        var field = fields[i];
        var field_value = this.data[ field.name ].trim();

        if( field.required && field_value == '' ){
          errors[field.name] = 'Il campo non può essere vuoto';
          errors_count++;
        }

        switch( field.type ){
          case 'text':
            
            break;
          case 'email':
              var email_pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
              if( !email_pattern.test(field_value) ){
                errors[field.name] = 'Formato email non valido';
                errors_count++;
              }
                
            break;
          case 'number':
            var number_pattern = /^\d+$/;
              if( !number_pattern.test(field_value) ){
                errors[field.name] = 'Formato numero non valido';
                errors_count++;
              }
                
            break;
        }
      }

      if( errors_count == 0){
        

        return true;
      }
      else{
        this.notification.error('Impossibile procedere. Si prega di verificare i campi indicati.');
        this.validation_errors = errors;
        return false;
      }

    },
    */

    submitForm: function(){
      this.insertWarranty();
    },


    insertWarranty: function( callback ){
       
      var self = this;

      var post_data = {
        data: this.data,
      };
    
      this.api.post( 'warranty/insertWarranty', post_data )
      .then(function (response) {
        

          if( response.data.success ){
            self.notification.success('Registrazione effettuata correttamente.');

            self.current_state = 'result';
            self.insert_result = response.data;
          }
          else{
            self.notification.error('Impossibile procedere. Si prega di verificare i campi indicati.');
            self.validation_errors = response.data.validation_errors;
            return false;
          }
        
          if( typeof callback === 'function')
            callback( response.data);
      })
      .catch(function (error) {
          self.notification.error('Errore nella registrazione della garanzia');
      });
    
    },

    
  },
  computed:{
    
  }
  
}
</script>
